import { matchPath } from 'react-router';
export const routes = {
    productDetailPage: '/painter/products/details/:asin',
    previewOrderPage: '/checkout/preview',
    paymentSelectionPage: '/checkout/payment-selection',
    thankYouPage: '/checkout/confirm',
    creatorStorefrontPage: '/painter/content/:aci',
    linkCampaignPage: '/painter/products/linkcampaign',
    storefrontPage: '/painter/products/store/:id',
    multiAsinLandingPage: '/painter/products/featured',
    paymentFailedPage: '/checkout/payment-failed',
};
/**
 * Returns the route data for a given pathname
 * @param pathname
 * @returns route data and bundle id
 */
export const getRouteData = (pathname) => {
    const route = {
        isPDP: !!matchPath(routes.productDetailPage, pathname),
        isPOP: !!matchPath(routes.previewOrderPage, pathname),
        isPSP: !!matchPath(routes.paymentSelectionPage, pathname),
        isTYP: !!matchPath(routes.thankYouPage, pathname),
        isCSF: !!matchPath(routes.creatorStorefrontPage, pathname),
        isLCP: !!matchPath(routes.linkCampaignPage, pathname),
        isSFP: !!matchPath(routes.storefrontPage, pathname),
        isMALP: !!matchPath(routes.multiAsinLandingPage, pathname),
    };
    let bundleId = '';
    if (route.isPDP) {
        bundleId = 'pages.productDetails';
    }
    else if (route.isPOP) {
        bundleId = 'pages.previewOrderPage';
    }
    else if (route.isPSP) {
        bundleId = 'pages.paymentSelectionPage';
    }
    else if (route.isTYP) {
        bundleId = 'pages.thankYouPage';
    }
    else if (route.isCSF || route.isSFP || route.isMALP) {
        bundleId = 'pages.storefrontPage';
    }
    else if (route.isLCP) {
        bundleId = 'pages.linkCampaign';
    }
    return { route, bundleId };
};
